<script>
    import { link } from 'svelte-routing';
    import { store, store_offer } from '../Store.svelte';
    import { env } from '../Environment.svelte';

    $store.requestedAddress = env.cleanstore.requestedAddress;
    $store.personalDetails = env.cleanstore.personalDetails;
    $store.requestedServices = env.cleanstore.requestedServices;
    $store_offer.loadedOffer = env.cleanstore_offer.loadedOffer;
    $store.purchaseStatus = env.cleanstore.purchaseStatus;
</script>

<main>
    <p>Store cleaned.</p>
    <a use:link href="/receiver/purchase/{env.defaultRedirectionToken}"
        >Return</a
    >
</main>
